import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { ProfileInfo } from 'modules/community/types/member-interface'
import { communityKeys } from '../api/key-factory'

export interface UseUserInfoProps {
  userId: number
  shouldFetch?: boolean
}

export default function useUserInfo({
  userId,
  shouldFetch = true,
}: UseUserInfoProps): UseQueryResult<ProfileInfo, Error> {
  const router = useRouter()
  const { communityPath } = router.query
  const path = Array.isArray(communityPath) ? communityPath[0] : communityPath

  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, ProfileInfo>({
    method: RequestMethodsEnum.get,
    notFoundResponseHandler: () => {},
  })

  return useQuery(
    queryOptions({
      queryKey: communityKeys.profileInfo(path, userId),
      queryFn: () => fetcher(`${COMMUNITY_API_PREFIX}/${path}/get-profile-info/${userId}`),
      enabled: shouldFetch && Boolean(path),
    }),
  )
}
